import React, {Dispatch, SetStateAction} from "react"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"
import {useTranslation} from "next-i18next"
import Button from "../../reusable/components/Button"
import {ArrowLeft, ArrowRight} from "react-bootstrap-icons"
import MoreWaysToFindEbikeQuizCta from "./MoreWaysToFindEbikeQuizCta"

function NarrowScope({setNarrowScope}:{setNarrowScope:Dispatch<SetStateAction<boolean>>}) {
	const {t} = useTranslation()
	return (
		<div className="d-flex flex-column justify-content-start col-12  align-items-start gap-2 text-black "
			style={{border: "1px solid #fefefe", borderRadius: "8px"}} >
			<Typography style={{fontSize: "20px", lineHeight: "32px"}}
				variant="bodySmBlack"
				className="d-flex align-items-center justify-content-start gap-1">{t("zero-results-title")}</Typography>

			<Typography style={{fontSize: "14px", lineHeight: "20px", maxWidth: "640px"}}
				variant="bodySm"><img src={"/assets/icons/ryder.svg"}
					width={24}
					height={24} />{t("ryder-greeting")} <b style={{color: "#A219D4"}}>Ryder</b> {t("zero-results-header")}</Typography>

			<Typography style={{fontSize: "14px", lineHeight: "20px"}}
				variant="bodySm">{t("zero-results-subheader")}</Typography>
			<Button bgColor="#FEC04D"
				icon={<ArrowLeft size={20} />}
				fontSizeSmall
				iconFirst
				className="col-12 mt-2"
				onClick={() => {
					setNarrowScope(false)
				}}
				label={t("back")} />
			<div className="px-3 mt-2 container border-top col-11" />
			<MoreWaysToFindEbikeQuizCta isBlack />
		</div>
	)
}

export default NarrowScope
